export default __webpack_public_path__ + "static/logo-540b439b6b1ab8e621c85eebcfe327f8.png";